import { Store } from "pullstate";
export default new Store({
  fcmToken: "",
  RNfcmToken: "",
  formDetails: {},
  reportDetails: {},
  uploadModal: {
    isOpen: false,
    hasCurrentPatient: false
  },
  isEditPatientOpen: false,
  isLogoutOpen: false,
  sharingPatient: 0,
  isGetFullAccessOpen: true,
  enableViewerAPICall: true,
  enableSidebarAPICall: false,
  patient: {},
  patientDetail: {},
  isDarkMode: null,
  isExportDataOpen: false,
  isStartingDownload: false,
  isChangeRegionModalOpen: false,
  isFindingsSettingsOpen: false,
  isAutomatedConditionOpen: false,
  isCreateUserGroup: false,
  isAutomatedFindingsOpen: false,
  isMatchingPatientOpen: false,
  isFormSelectorVisible: false,
  formName: "",
  formId: "",
  isIncomingForm: false,
  isPatientInfoFormCompleted: false,
  emergencyPatientId: null,
  isEmergencyModalOpen: false,
  isConfirmationModalOpen: false,
  filterToDeleteId: null,
  userSettings: {},
  appConfig: {},
  downloadExport: false,
  isExportReady: false,
  downloadProgress: 0,
  exportTimestamp: "",
  exportGenFailed: false,
  swiftModeEnabled: false,
  isRNTestBuild: false,
  RNSelectedEnv: "PROD",
  isRNEnvSelectorOpen: false,
  showExportUpdate: false,
  isRNAppStateChange: false,
  RNAppVersion: "",
  newPatientId: "",
  isNotificationSubscribing: false,
  showMobileStudySelector: false,
  hasUpdatedStudy: false,
  isRemoteAccessOpen: false,
  showMobileReport: false,
  isQXRModality: false,
  addPhoneModal: false,
  hasLicenseExpiredForSelectedPatient: false,
  isSettingsOpen: false,
  hasUnsavedSetting: false,
  selectedSetting: "",
  settingPageNo: 0,
  settingParams: {},
  showUnsavedWarning: false,
  isDiskSpaceWarning: false,
  patientsFileDeletionStatus: "",
  worklistSyncStatus: {},
  lastGoogleCheckStatus: null,
  hasQsyncDataFromOnline: false,
  hasMobileSearch: false,
  worklistCloudSyncStatus: {},
  isqTrack: false,
  isAssistantOpen: false,
  isDraggableModalOpen: false,
  isDraggableModalMinimized: false,
  isDraggableModalMaximized: false,
  chatInputContent: "",
  formList: {},
  updatePatientTags: false,
  refetchCustomFields: false,
  workspaceAudibleNotifications: false,
  selectedPocusTabIndex: 0,
  isScanAssistModalOpen: false,
  mwlConfig: undefined,
  navigatingToNewPatientUid: null,
  patientPayloadFromCreate: null,
  scanAssistRefetchTrigger: 0,
  scanAssistStatus: null,
  openScanCountModalTrigger: 0,
  canEditScanCount: null,
  us1ReuploadPending: false,
  pocusReviewSubmittedPatientId: null,
  pocusPatientDetailWsPatientUid: null,
  pocusPatientDetailApiData: null,
  finalDiagnosisResultTrigger: 0,
  pocusCineLoopSelected: false
});